export default __webpack_public_path__ + "static/media/food.c5c3f215.jpeg";